// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2J4PU","alert":"SettungsInbox_alert__lYNIw"};